import React, { Component } from "react";
import { Sidebar } from "primereact/sidebar";
import { confirmAlert } from "react-confirm-alert";
import Loader from "../components/Loader";
import SuccessDialog from "../components/SuccessDialog";
import { Dialog } from "primereact/dialog";
import { Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import api from "../service/ApiService";
import { postAddEnrollMentUrl, getAddEnrollMentUrl } from "../service/ApiUrls";
import { EnrollmentTypeEnum } from "../Enums";

export class SideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleRight: false,
      isLoading: false,
      isSuccess: false,
      isUpdate: false,
      isError: false,
      errorMsg: "",
      rowId: null,

      // Data Lists from API
      selectProfileList: [],
      selectDivisionList: [],
      selectGroupList: [],

      // Form Fields
      configName: "",
      selectedProfile: null, // Full Object
      selectedDivision: null, // Full Object
      selectedGroup: null, // Full Object
      defaultSetting: false,
      enableAllSystemApp: false,
      useMobileData: false,
    };
  }

  // Generic Get API Call
  callgetAddEnrollMent = async () => {
    try {
      const res = await api.get(getAddEnrollMentUrl);
      const { data, result } = res.data;
      return {
        content: data.content,
        groupList: data.groupList || [],
        profileList: data.profileList || [],
        divisionList: data.divisionList || [],
        isError: result.isError,
        errorMsg: result.errorMsg,
      };
    } catch (err) {
      console.error("Fetch Error:", err);
      return { isError: true, errorMsg: "Failed to load configuration data", groupList: [], profileList: [], divisionList: [] };
    }
  };

  launchSide = async (rowData, toUpdate) => {
    this.setState({
      visibleRight: true,
      isLoading: true,
      isError: false,
      errorMsg: "",
      isUpdate: !!toUpdate,
      rowId: rowData ? rowData.id : null,
    });

    const response = await this.callgetAddEnrollMent();

    if (response.isError) {
      this.setState({ isError: true, errorMsg: response.errorMsg, isLoading: false });
      return;
    }

    const { groupList, profileList, divisionList } = response;
    const accType = localStorage.getItem("accType");
    if (toUpdate && rowData) {
      // Find objects matching the IDs in rowData
      const foundProfile = profileList.find(p => p.id === rowData.profileId);
      const foundDivision = divisionList.find(d => d.id === rowData.divisionId);
      const foundGroup = groupList.find(g => g.id === rowData.groupId);

      this.setState({
        selectGroupList: groupList,
        selectProfileList: profileList,
        selectDivisionList: divisionList,
        configName: rowData.name || "",
        selectedProfile: foundProfile || null,
        selectedDivision: foundDivision || null,
        selectedGroup: foundGroup || null,
        defaultSetting: rowData.isDefault || false,
        enableAllSystemApp: rowData.enableAllSystemApp || false,
        useMobileData: rowData.useMobileData || false,
        isLoading: false,
      });
    } else {
      // Initialize for New Entry
      this.setState({
        selectGroupList: groupList,
        selectProfileList: profileList,
        selectDivisionList: divisionList,
        configName: "",
        selectedProfile: null,
        selectedDivision: divisionList.length > 0 ? divisionList[0] : null,
        selectedGroup: null,
        defaultSetting: false,
        enableAllSystemApp: false,
        useMobileData: false,
        isLoading: false,
      });
    }
  };

  submitHandler = async (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    console.log("this.state", this.state)
    // Payload Construction using state IDs
    const payload = {
      id: this.state.rowId,
      name: this.state.configName,
      profileId: this.state.selectedProfile ? this.state.selectedProfile.id : null,
      divisionId: this.state.selectedDivision ? this.state.selectedDivision.id : null,
      groupId: this.state.selectedGroup ? this.state.selectedGroup.id : null,
      isDefault: this.state.defaultSetting,
      osType: this.state.selectedProfile?.osType || 0,
      type: EnrollmentTypeEnum.QR,
      enableAllSystemApp: this.state.enableAllSystemApp,
      useMobileData: this.state.useMobileData,
    };
    console.log("payload", payload)
    if (!this.state.isUpdate) {
      // ADD Logic
      api.post(postAddEnrollMentUrl, payload).then((res) => {
        const { isError, errorMsg } = res.data.result;
        if (!isError) {
          this.handleSuccess("Added Successfully");
        } else {
          this.setState({ isError: true, errorMsg: errorMsg, isLoading: false });
        }
      });
    } else {
      // EDIT Logic
      const response = await this.props.apiUpdateCall(payload);
      if (!response.isError) {
        this.handleSuccess("Updated Successfully");
      } else {
        this.setState({ isError: true, errorMsg: response.errorMsg, isLoading: false });
      }
    }
  };

  handleSuccess = (msg) => {
    this.props.apiParentCall();
    this.setState({ visibleRight: false, isLoading: false }, () => {
      confirmAlert({
        title: "Success Message",
        message: <p className="mod-sp">{msg}</p>,
        buttons: [{ label: "Ok" }],
      });
    });
  };

  render() {
    return (
      <div>
        <Dialog visible={this.state.isLoading} modal closable={false} showHeader={false} style={{ width: "20vw" }}>
          <Loader />
        </Dialog>

        <Sidebar
          visible={this.state.visibleRight}
          position="right"
          baseZIndex={1000000}
          onHide={() => this.setState({ visibleRight: false })}
          style={{ width: "30em" }}
        >
          <h2 style={{ fontWeight: "normal" }}>
            {this.state.isUpdate ? "Edit " : "Create "} Config
          </h2>
          <hr />

          <div className="content-section implementation">
            {this.state.isError && (
              <Alert variant="danger" style={{ textAlign: "center" }}>
                <b>{this.state.errorMsg}</b>
              </Alert>
            )}

            <form onSubmit={this.submitHandler}>
              {/* Config Name */}
              <div className="form-group mb-3">
                <label>Config Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={this.state.configName}
                  onChange={(e) => this.setState({ configName: e.target.value })}
                  placeholder="Enter Config Name"
                  required
                />
              </div>
              {/* Division Dropdown */}
              <div className="form-group mb-3">
                <label>Select Division</label>
                <select
                  className="form-control"
                  value={this.state.selectedDivision?.id || ""}
                  onChange={(e) => {
                    // Extra safety: only update if not restricted
                    if (localStorage.getItem("accType") !== "1") {
                      const obj = this.state.selectDivisionList.find(d => d.id === e.target.value);
                      this.setState({ selectedDivision: obj });
                    }
                  }}
                  // LOGIC: Disable if accType is 1
                  disabled={localStorage.getItem("accType") === "1" || this.state.isUpdate}
                  required
                >
                  {/* If restricted, we don't show the empty 'Select' option to prevent invalid state */}
                  {localStorage.getItem("accType") !== "1" && <option value="">Select Division</option>}

                  {this.state.selectDivisionList.map(d => (
                    <option key={d.id} value={d.id}>{d.name}</option>
                  ))}
                </select>
              </div>
              {/* Profile Dropdown */}
              <div className="form-group mb-3">
                <label>Select Profile</label>
                <select
                  className="form-control"
                  value={this.state.selectedProfile?.id || ""}
                  onChange={(e) => {
                    const obj = this.state.selectProfileList.find(p => p.id === e.target.value);
                    this.setState({ selectedProfile: obj });
                  }}
                  required
                >
                  <option value="">Select Profile</option>
                  {this.state.selectProfileList.map(p => (
                    <option key={p.id} value={p.id}>{p.name}</option>
                  ))}
                </select>
              </div>

              {/* Is Default Radio */}
              <div className="form-group mb-4">
                <label className="d-block">Is Default</label>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="defaultSetting"
                    checked={this.state.defaultSetting === true}
                    onChange={() => this.setState({ defaultSetting: true })}
                  />
                  <label className="form-check-label">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="defaultSetting"
                    checked={this.state.defaultSetting === false}
                    onChange={() => this.setState({ defaultSetting: false })}
                  />
                  <label className="form-check-label">No</label>
                </div>
              </div>

              <button type="submit" className="btn btn-primary w-100 py-2">
                {this.state.isUpdate ? "Update Config" : "Save Config"}
              </button>
            </form>
          </div>
        </Sidebar>

        <button
          className="btn btn-primary"
          onClick={() => this.launchSide(null, false)}
          style={{ float: "right" }}
        >
          + New Config
        </button>
      </div>
    );
  }
}

export default SideMenu;